@use "styles/abstracts/variables" as v;

.button {
    font-family: v.$primary-font;
    background-color: v.$palette-gray-200;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    padding: 0;
    border: none;
    user-select: none;
    transition: background-color 250ms, color 250ms;

    svg path {
        fill: v.$palette-gray-900;
    }

    &:hover {
        background-color: v.$palette-blue-light-2;
        color: v.$palette-blue;

        svg path {
            fill: v.$palette-blue;
        }
    }

    &.isOpenFilter {
        background-color: v.$palette-blue-light-5;
        color: v.$palette-blue;

        svg {
            path {
                fill: v.$palette-blue;
            }
        }
    }
}

:global([data-theme="dark"]) {
    .button:not(:hover):not(.isOpenFilter) svg path {
        fill: v.$palette-pure-white;
    }
}